module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('strong', [_vm._v("PRINCIPAL ABBREVIATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ADAJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Annual of the Department of Antiquities of Jordan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("AJSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("American Journal of Semitic Languages")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Akk.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Akkadian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ANET(S)")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("J. B. Pritchard, ed., "), _c('em', [_vm._v("Ancient Near Eastern Texts")]), _vm._v(" ("), _c('sup', [_vm._v("2")]), _vm._v("1955, "), _c('sup', [_vm._v("3")]), _vm._v("1969); Supplement (1969)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Arab.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Arabic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ARAB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("D. D. Luckenbill, "), _c('em', [_vm._v("Ancient Records of Assyria and Babylonia")]), _vm._v(", 2 vols. (1926–27)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ARM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Archives Royales de Mari")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ATD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Das Alte Testament Deutsch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Authorised (King James) Version of the Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("BJRL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Bulletin of the John Rylands Library")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("CAD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("The Assyrian Dictionary of the Oriental Institute of the University of Chicago")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("EQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("E.T.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("English Translation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Good News Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Handbuch zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Interpreter’s Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Interpreter’s Dictionary of the Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal Asiatique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JBC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("The Jerome Bible Commentary")]), _vm._v(" (1969)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('em', [_vm._v("JBL")])])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JCS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of Cuneiform Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JNES")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of Near Eastern Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JPOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of the Palestine Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of Semitic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("KB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Koehler and Baumgartner, "), _c('em', [_vm._v("Lexicon in Veteris Testamenti Libros")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("NBD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("J. D. Douglas, ed., "), _c('em', [_vm._v("The New Bible Dictionary")]), _vm._v(" (1962)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("The New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("OTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Oudtestamentische Studiën")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Palestine Exploration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Revue Biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("RHPR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Revue d’Histoire et de Philosophic Religieuses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Revised Standard Version of the Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("RV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Revised Version of the Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SVT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Supplements to "), _c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Syr.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Syriac")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("UF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Ugarit-Forschungen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Ugar.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Ugaritic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("UT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("C. H. Gordon, "), _c('em', [_vm._v("Ugaritic Textbook")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Vulg.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Vulgate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("WMANT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Wissenschaftliche Monographien zum Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019af3b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0